import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

import { tasa } from "../dominio/panelInicio";

/** Piezas comunes del panel de Inicio y del informe mensual (45 y 47). */

export const Bloque = ({
  titulo,
  ayuda,
  children,
  className,
  accion,
  testid,
  guia,
}: {
  titulo: string;
  ayuda?: string;
  children: ReactNode;
  className?: string;
  /** Algo a la derecha del título (un enlace, un interruptor). */
  accion?: ReactNode;
  testid?: string;
  /** Marca para la guía (data-guia). */
  guia?: string;
}) => (
  <section
    className={cn("superficie space-y-4 p-5", className)}
    data-testid={testid}
    data-guia={guia}
  >
    <div className="flex items-start justify-between gap-3">
      <div className="space-y-0.5">
        <h2 className="titulo-seccion">{titulo}</h2>
        {ayuda ? (
          <p className="text-xs text-muted-foreground">{ayuda}</p>
        ) : null}
      </div>
      {accion}
    </div>
    {children}
  </section>
);

export const Th = ({
  children,
  derecha,
}: {
  children: ReactNode;
  derecha?: boolean;
}) => (
  <th
    className={cn(
      "pb-2 text-xs font-medium text-muted-foreground",
      derecha && "pl-3 text-right",
    )}
  >
    {children}
  </th>
);

export const Td = ({
  children,
  derecha,
}: {
  children: ReactNode;
  derecha?: boolean;
}) => (
  <td className={cn("py-2 text-sm", derecha && "pl-3 text-right tabular-nums")}>
    {children}
  </td>
);

/** a / b en % con una barrita (solo %, nunca el recuento suelto). */
export const Pct = ({ a, b }: { a: number; b: number }) => {
  const v = tasa(a, b);
  return (
    <span className="inline-flex items-center justify-end gap-2">
      <span className="hidden h-1.5 w-14 overflow-hidden rounded-full bg-foreground/[0.06] sm:block">
        <span
          className="block h-full rounded-full bg-[var(--serie-llamadas)]"
          style={{ width: `${v ?? 0}%` }}
        />
      </span>
      <span className="w-10 text-right">{v == null ? "—" : `${v} %`}</span>
    </span>
  );
};

/** Una cifra pequeña con su etiqueta (bloques de velocidad, dinero, previsión). */
export const Dato = ({
  etiqueta,
  valor,
  detalle,
}: {
  etiqueta: string;
  valor: string;
  detalle?: string | null;
}) => (
  <div className="space-y-1">
    <dt className="etiqueta leading-tight">{etiqueta}</dt>
    <dd className="cifra-grande text-2xl leading-none">{valor}</dd>
    {detalle ? (
      <dd className="text-xs text-muted-foreground">{detalle}</dd>
    ) : null}
  </div>
);
